import { Loader } from '@/components/loading/Loading';

import clsx from 'clsx';
import { ButtonHTMLAttributes, FC, HTMLAttributes, PropsWithChildren } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export const Card: FC<CardProps> = ({ className, children, ...props }) => {
  return (
    <div {...props} className={clsx('border-secondary-std rounded-lg border bg-white', className)}>
      {children}
    </div>
  );
};

export const Action: FC<PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean }>> = ({
  className,
  children,
  loading,
  ...props
}) => {
  return (
    <button
      {...props}
      className={clsx(
        'border-secondary-std hover:bg-primary-std relative border-t p-2 text-sm font-medium disabled:opacity-60',
        className
      )}
    >
      {loading ? (
        <span className={clsx('absolute inset-0 flex items-center justify-center', 'bg-primary-std')}>
          <Loader className="h-6 w-6" />
        </span>
      ) : null}
      {children}
    </button>
  );
};
